import AdminLoginPage from "@/views/admin/AdminLoginPage.vue";
import AdminAccountManageListPage from "@/views/admin/account/AdminAccountManageListPage.vue";
import AdminAccountCreatePage from "@/views/admin/account/AdminAccountCreatePage.vue"
import AccountManageListPage from "@/views/admin/account/AccountManageListPage.vue";
import AccountManageCreatePage from "@/views/admin/account/AccountManageCreatePage.vue";
import BoardNoticeManageListPage from "@/views/admin/board/BoardNoticeManageListPage.vue";
import BoardNoticeCreatePage from "@/views/admin/board/BoardNoticeCreatePage.vue";
import FaqManageListPage from "@/views/admin/board/FaqManageListPage.vue";
import FaqManageCreatePage from "@/views/admin/board/FaqManageCreatePage.vue";
import PopupManageListPage from "@/views/admin/etc/PopupManageListPage.vue";
import PopupManageCreatePage from "@/views/admin/etc/PopupManageCreatePage.vue";
import CategoryManageListPage from "@/views/admin/etc/CategoryManageListPage.vue";
import CategoryManageCreatePage from "@/views/admin/etc/CategoryManageCreatePage.vue";
import BoardNoticeEditPage from "@/views/admin/board/BoardNoticeEditPage.vue";
import SponsorManageListPage from "@/views/admin/board/SponsorManageListPage.vue";
import SponsorManageCreatePage from "@/views/admin/board/SponsorManageCreatePage.vue";
import DonationGroupManageListPage from "@/views/admin/board/DonationGroupManageListPage.vue";
import DonationGroupManageCreatePage from "@/views/admin/board/DonationGroupManageCreatePage.vue";
import CampaignManageListPage from "@/views/admin/product/CampaignManageListPage.vue";
import CampaignManageCreatePage from "@/views/admin/product/CampaignManageCreatePage.vue";
import CampaignPaymentListPage from "@/views/admin/product/CampaignPaymentListPage.vue";
import PartnerManageListPage from "@/views/admin/etc/PartnerManageListPage.vue";
import PartnerManageCreatePage from "@/views/admin/etc/PartnerManageCreatePage.vue";
import InquiryManageListPage from "@/views/admin/etc/InquiryManageListPage.vue";
import InquiryAnswerPage from "@/views/admin/etc/InquiryAnswerPage.vue";
import MerchantManageCreatePage from "@/views/admin/merchant/MerchantManageCreatePage.vue";
import MerchantManageListPage from "@/views/admin/merchant/MerchantManageListPage.vue";
import MerchantManageEditPage from "@/views/admin/merchant/MerchantManageEditPage.vue";
import InvitationWeddingListPage from "@/views/admin/product/InvitationWeddingListPage.vue";
import InvitationFuneralListPage from "@/views/admin/product/InvitationFuneralListPage.vue";
import CampaignCategoryManageListPage from "@/views/admin/etc/CampaignCategoryManageListPage.vue";
import CampaignCategoryManageCreatePage from "@/views/admin/etc/CampaignCategoryManageCreatePage.vue";
import DonationCategoryManageListPage from "@/views/admin/etc/DonationCategoryManageListPage.vue";
import DonationCategoryManageCreatePage from "@/views/admin/etc/DonationCategoryManageCreatePage.vue";

const adminRoutes = [
    {
        path: "/admin",
        // component: () => import("@/layouts/AdminLayout.vue"),
        children: [
          {
            path: "login",
            name: "AdminLoginPage",
            component: AdminLoginPage,
          },
          {
            path: "admin-account-list",
            name: "AdminAccountManageListPage",
            component: AdminAccountManageListPage,
          },
          {
            path: "admin-account-manage",
            name: "AdminAccountCreatePage",
            component: AdminAccountCreatePage,
          },
          {
            path: "account-list",
            name: "AccountManageListPage",
            component: AccountManageListPage,
          },
          {
            path: "account-create",
            name: "AccountManageCreatePage",
            component: AccountManageCreatePage,
          },
          {
            path: "board-notice-list",
            name: "BoardNoticeManageListPage",
            component: BoardNoticeManageListPage,
          },
          {
            path: "board-notice-create",
            name: "BoardNoticeCreatePage",
            component: BoardNoticeCreatePage,
          },
          {
            path: "board-faq-list",
            name: "FaqManageListPage",
            component: FaqManageListPage,
          },
          {
            path: "board-faq-create",
            name: "FaqManageCreatePage",
            component: FaqManageCreatePage,
          },
          {
            path: "popup-list",
            name: "PopupManageListPage",
            component: PopupManageListPage,
          },
          {
            path: "popup-create",
            name: "PopupManageCreatePage",
            component: PopupManageCreatePage,
          },
          {
            path: "category-list",
            name: "CategoryManageListPage",
            component: CategoryManageListPage,
          },
          {
            path: "category-create",
            name: "CategoryManageCreatePage",
            component: CategoryManageCreatePage,
          },
          {
            path: "board-notice-edit/:noticeSeq",
            name: "BoardNoticeEditPage",
            components: {
              default: BoardNoticeEditPage,
            },
            props: {
              default: true,
            },
          },
          {
            path: "sponsor-list",
            name: "SponsorManageListPage",
            component: SponsorManageListPage,
          },
          {
            path: "sponsor-create",
            name: "SponsorManageCreatePage",
            component: SponsorManageCreatePage,
          },
          {
            path: "donation-group-list",
            name: "DonationGroupManageListPage",
            component: DonationGroupManageListPage,
          },
          {
            path: "donation-group-create",
            name: "DonationGroupManageCreatePage",
            component: DonationGroupManageCreatePage,
          },
          {
            path: "campaign-list",
            name: "CampaignManageListPage",
            component: CampaignManageListPage,
          },
          {
            path: "campaign-create",
            name: "CampaignManageCreatePage",
            component: CampaignManageCreatePage,
          },
          {
            path: "campaign-payment-list",
            name: "CampaignPaymentListPage",
            component: CampaignPaymentListPage,
          },
          {
            path: "partner-create",
            name: "PartnerManageCreatePage",
            component: PartnerManageCreatePage
          },
          {
            path: "partner-list",
            name: "PartnerManageListPage",
            component: PartnerManageListPage
          },
          {
            path: "inquiry-list",
            name: "InquiryManageListPage",
            component: InquiryManageListPage
          },
          {
            path: "inquiry-manage",
            name: "InquiryAnswerPage",
            component: InquiryAnswerPage
          },
          {
            path: "merchant-create",
            name: "MerchantManageCreatePage",
            component: MerchantManageCreatePage
          },
          {
            path: "merchant-manage",
            name: "MerchantManageListPage",
            component: MerchantManageListPage
          },
          {
            path: "merchant-edit/:authSeq",
            name: "MerchantManageEditPage",
            components: {
              default: MerchantManageEditPage,
            },
            props: {
              default: true,
            },
          },
          {
            path: "wedding-list",
            name: "InvitationWeddingListPage",
            component: InvitationWeddingListPage
          },
          {
            path: "funeral-list",
            name: "InvitationFuneralListPage",
            component: InvitationFuneralListPage
          },
          {
            path: "campaign-category-list",
            name: "CampaignCategoryManageListPage",
            component: CampaignCategoryManageListPage
          },
          {
            path: "campaign-category-create",
            name: "CampaignCategoryManageCreatePage",
            component: CampaignCategoryManageCreatePage
          },
                    {
            path: "donation-category-list",
            name: "DonationCategoryManageListPage",
            component: DonationCategoryManageListPage
          },
          {
            path: "donation-category-create",
            name: "DonationCategoryManageCreatePage",
            component: DonationCategoryManageCreatePage
          },
        ],
      },
]

export default adminRoutes;